module.exports = __webpack_public_path__ + "static/media/step1.a4a3e75c.svg";